import React from 'react';
import { mealPlaceholderImage } from '@front-activerse/common-components';
import { UnifiedMealData } from '../../types';

interface TrackerMealImageProps {
  mealData: UnifiedMealData;
  appBrand: string;
  customImageUrl?: string | null;
  cameraIcon?: string;
  onCameraClick?: () => void;
}

const TrackerMealImage: React.FC<TrackerMealImageProps> = ({
  mealData,
  appBrand,
  customImageUrl,
  cameraIcon,
  onCameraClick,
}) => {
  let mealImg: string;
  if (customImageUrl) {
    mealImg = customImageUrl;
  } else if (mealData.preparationImageUrl) {
    mealImg = mealData.preparationImageUrl;
  } else if (mealData.mealType !== undefined) {
    mealImg = mealPlaceholderImage(mealData.mealType, appBrand);
  } else {
    mealImg = mealData.preparationImageUrl ?? '';
  }
  return (
    <div className="position-relative d-inline-block w-100">
      <img
        src={mealImg}
        className="img-fluid rounded mb-3 mb-md-0"
        width="502"
        height="502"
        alt=""
      />
      {cameraIcon && onCameraClick && (
        <button
          type="button"
          className="position-absolute border-0 bg-transparent p-0"
          style={{ top: '12px', right: '12px' }}
          onClick={onCameraClick}
        >
          <img src={cameraIcon} alt="" width={32} height={32} />
        </button>
      )}
    </div>
  );
};

export default TrackerMealImage;
